import React, { useState } from 'react';

const AuthorBio = ({ post }) => {
  const [expanded, setExpanded] = useState(false);

  if (!post?.author_name) return null;

  return (
    <div
      style={{
        marginTop: '64px',
        padding: '32px',
        background: '#0D1520',
        border: '1px solid rgba(59,111,212,0.2)',
        position: 'relative',
        transform: 'rotate(-0.3deg)'
      }}
    >
      {/* Decorative corner */}
      <div style={{ position: 'absolute', top: 0, left: 0, width: '40px', height: '40px', borderTop: '3px solid #3B6FD4', borderLeft: '3px solid #3B6FD4' }} />
      <div style={{ position: 'absolute', bottom: 0, right: 0, width: '40px', height: '40px', borderBottom: '3px solid #3B6FD4', borderRight: '3px solid #3B6FD4' }} />

      <p style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.65rem', fontWeight: 700, color: '#3B6FD4', letterSpacing: '0.25em', textTransform: 'uppercase', margin: '0 0 20px' }}>Om forfatteren</p>

      <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
        {post?.author_avatar && (
          <div style={{ flexShrink: 0 }}>
            <img
              src={post?.author_avatar}
              alt={`Portrett av ${post?.author_name}`}
              style={{
                width: '72px',
                height: '72px',
                borderRadius: '50%',
                objectFit: 'cover',
                border: '3px solid rgba(59,111,212,0.4)',
                transform: 'rotate(2deg)'
              }}
            />
          </div>
        )}
        <div style={{ flex: 1 }}>
          <h3 style={{ fontFamily: 'Syne, sans-serif', fontSize: '1.1rem', fontWeight: 800, color: '#EEF0F2', margin: '0 0 6px', letterSpacing: '-0.02em' }}>
            {post?.author_name}
          </h3>
          {post?.author_bio && (
            <>
              <p
                style={{
                  fontFamily: 'Georgia, serif',
                  fontSize: '0.9rem',
                  color: 'rgba(238,240,242,0.65)',
                  lineHeight: 1.7,
                  margin: '0 0 12px',
                  display: expanded ? 'block' : '-webkit-box',
                  WebkitLineClamp: expanded ? 'unset' : 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: expanded ? 'visible' : 'hidden'
                }}
              >
                {post?.author_bio}
              </p>
              <button
                onClick={() => setExpanded(!expanded)}
                style={{
                  fontFamily: 'Syne, sans-serif',
                  fontSize: '0.72rem',
                  fontWeight: 700,
                  color: '#3B6FD4',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  letterSpacing: '0.1em',
                  textTransform: 'uppercase',
                  padding: 0
                }}
              >
                {expanded ? '↑ Vis mindre' : '↓ Les mer om forfatteren'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthorBio;
